module.exports = __webpack_public_path__ + "img/sad_face_no_border.14be4b99.svg";